import { ReactKeycloakProvider } from '@react-keycloak/web';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import keycloak, { keycloakInitOptions } from './config/keycloak';
import { MainLayout } from './components/Layout/MainLayout';
import { TokenList } from './components/Tokens/TokenList';
import { ProviderList } from './components/Providers/ProviderList';
import { ProviderForm } from './components/Providers/ProviderForm';
import { ProviderEditForm } from './components/Providers/ProviderEditForm';
import { TemplateSelector } from './components/Templates/TemplateSelector';
import { TemplateForm } from './components/Templates/TemplateForm';
import { Loader2 } from 'lucide-react';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Loading component
const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <Loader2 className="h-12 w-12 animate-spin text-primary-600 mx-auto mb-4" />
      <p className="text-gray-600">Initializing authentication...</p>
    </div>
  </div>
);

const basePath = (import.meta.env.VITE_BASE_URL || '/').replace(/\/+$/, '') || '/';

function App() {
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakInitOptions}
      LoadingComponent={<LoadingScreen />}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={basePath}>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Navigate to="/tokens" replace />} />
              <Route path="/tokens" element={<TokenList />} />
              <Route path="/providers" element={<ProviderList />} />
              <Route path="/providers/new" element={<ProviderForm />} />
              <Route path="/providers/:id/edit" element={<ProviderEditForm />} />
              <Route path="/templates" element={<TemplateSelector />} />
              <Route path="/templates/new" element={<TemplateForm />} />
              <Route path="/templates/:id/edit" element={<TemplateForm />} />
              <Route path="*" element={<Navigate to="/tokens" replace />} />
            </Routes>
          </MainLayout>
        </BrowserRouter>
      </QueryClientProvider>
    </ReactKeycloakProvider>
  );
}

export default App;
